<template>
	<header class="top-nav" id="top-nav">
		<div class="nav-container">
			<div class="logo" @click="$router.replace({path: '/'})">
				<img src="../assets/logo.png" alt="岱屿画境">
			</div>
		</div>
		<div class="userInfo">
			<el-popover placement="bottom" trigger="hover">
				<div class="logoutBox"
					style="width: 1.36rem;background: #FFFFFF;display: flex;flex-direction: column;align-items: center;">
					<img class="logoutAvatar"
						style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
						:src="userInfo.avatar" v-if="userInfo.avatar" />
					<img class="logoutAvatar"
						style="width: .64rem;height: .64rem;border-radius: 50%;object-fit: cover;"
						src="../assets/defaultAvatar.png" v-else />
					<div class="userName"
						style="margin-top: .12rem;font-weight: 500;font-size: .16rem;color: #252525;line-height: .24rem;">
						{{userInfo.hs_name}}
					</div>
					<div class="userId"
						style="margin-top: .02rem;font-weight: 400;font-size: .12rem;color: #666666;">
						NO.{{userInfo.tj_num}}</div>
					<div class="logout"
						style="margin-top: .24rem;width: 1.08rem;height: .36rem;border-radius: .06rem;border: .01rem solid #E29358;font-weight: 400;font-size: .14rem;color: #E29358;text-align: center;line-height: .36rem;cursor: pointer;"
						@click="logout">
						退出登录</div>
				</div>
				<div class="userInfo" slot="reference">
					<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
					<img class="avatar" src="../assets/defaultAvatar.png" v-else />
					<div class="userName">
						{{userInfo.hs_name}}
					</div>
				</div>
			</el-popover>
		</div>
	</header>
</template>

<script>
	export default {
		name: 'TopNavBarH',
		data() {
			return {
				keywords: '',
				userInfo: {},
				searchPop: false,
				userId: '',
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userId = localStorage.getItem('userId')
				this.userDetails()
			}
		},
		methods: {
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			logout() {
				localStorage.clear();
				this.$store.dispatch('updateShopStatus', 1)
				this.$router.replace({
					path: '/login'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.top-nav {
		position: sticky;
		top: 0;
		height: .64rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #FFFFFF;
		z-index: 99;
	}

	.nav-container {
		max-width: 12rem;
		margin-left: .24rem;
		display: flex;
		align-items: center;
		height: .64rem;
	}

	.logo {
		display: flex;
		width: 1.5rem;
		height: .3rem;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.userInfo {
		margin-right: .24rem;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.avatar {
		width: .24rem;
		height: .24rem;
		border-radius: 50%;
	}

	.userName {
		margin-left: .08rem;
		font-weight: 400;
		font-size: .14rem;
		color: #1A1A1A;
	}
</style>